import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import Avatar from '@material-ui/core/Avatar';
// import { Icon } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
  }));

const StandardList = props => {
    const { dataList, primary, secondary, selectItem, key} = props
    const classes = useStyles();
    return (
        <List className={classes.root}>
            {
                dataList.map( data => {
                    return  <ListItem key = {data.id ? data.id : key} button onClick={() => selectItem(data)} >
                                <ListItemAvatar style={{minWidth: '30px'}}>
                                    <img src={process.env.PUBLIC_URL + '/icons/comun.png'} alt="Logo"  /> 
                                </ListItemAvatar>
                                <ListItemText
                                    primary={<span style = { data.pstyle ? data.pstyle : {}} >{ `${data[primary]}` }</span>}
                                    secondary={<span style = { data.sstyle ? data.sstyle : {color: '#000000'}} >{ data[secondary] }</span>} />
                            </ListItem>
                })
            }
        </List>
    );
};

StandardList.propTypes = {
    dataList: PropTypes.array.isRequired,
    primary: PropTypes.string.isRequired,
    secondary: PropTypes.string.isRequired,
    selectItem: PropTypes.func.isRequired,
    icon: PropTypes.node,
};

export default StandardList;